import { createFileRoute } from '@tanstack/react-router'
export const Route = createFileRoute('/_auth/host')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <iframe
      title="Admin"
      style={{ height: '100%', border: 'none' }}
      src="/ll/embedded.html#admin"
    />
  )
}
